import React, { useReducer } from "react";
import axios from 'axios';
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import AuthService from "services/auth.service";

import { withRouterJim } from "router/withRouterJim";
import NuConfirm from "components/nubox/Box/NuConfirm";
import  NuDropdown from "components/nubox/NuDropdown";

import cApi from 'helpers/cApi'

import user from 'assets/img/user.jpg';
import user1 from 'assets/img2/user1.png';


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";


const cbo=[
  {  value:'1', label: 'label1'},
  {  value:'2', label: 'Clss'},
  {  value:'3', label: 'Nod'},
  {  value:'4', label: 'Lod'},
  {  value:'5', label: 'Elggg'},
]

const form_reset={
  idd:0,
  ope:'n', 
  nro_doc:'',
  
}

const row={
  cant:0,
  medicamento:'', 
  dosis:1,
  unidad:'COM',
  duracion:0,
}

//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class EstudiantePreins extends React.Component {
  
  modalRef = React.createRef();//create ref

  state = {
    modalImagen: false,
    id_paciente: 0,
    id_receta:0,
    
    form: form_reset,
    data:[], /* tratamientos_det */

    arr_carr_preins:[],
    arr_duracion:[
      {  value:'1', label: 'c/8 H'},
      {  value:'2', label: 'c/12 H'},
      {  value:'3', label: 'c/24 H'},
    ]
  };
  
   //--------------------------------------
   constructor(props) {
    super(props);

    this.refNuConfirm = React.createRef();
  }
  //------------------
  //------------------------------------------------------
  componentDidMount() {
    //--limpiamos el array de prueba
    this.setState({data:[]});
    this.cargar_carreras_a_preinscribir();

    const user = AuthService.getCurrentUser();

    let id_paciente = this.props.store.paciente.id_paciente;
    // Get the userId param from the URL.
    let idd = this.props.params.idd;
    let ope = this.props.params.ope;  
    console.log("idd: "+ idd + " ope:" + ope);
    if(ope==='e' || ope==='x'){
      this.cargar_receta(idd);
      
    }

    if(ope==='n'){
      this.limpiar();
    }

    this.setState({ form:{
        ...this.state.form, 
        idd: idd, 
        ope: ope,
      },
      id_paciente: id_paciente,
      id_receta: idd,
    }); 
    

  }
  //---------------------------------------
  // id_carre, nombreca, descripca
  cargar_carreras_a_preinscribir = () => {
    let param = { 
    }
    
    axios2.post("estudiante_preins_carrera_get_list", param)
    .then(res => {
        this.setState({arr_carr_preins: res.data});
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
    });
  };
  //---------------------------------------
  limpiar(){
    this.setState({form: form_reset, data: []});
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      let res = e.target.checked? 1:0;
            
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  
  //---------------------------------
  //====================================================== 
  //----cargamos los datos desde la base de datos
  find_preins = (nro_doc) => {
    
    //context API
    console.log("---cargar preinscripcion----");
    
    let param = { 
      nro_doc: nro_doc
    }
    console.log(param);
    axios2.post( "estudiante_preins_find_preins", param).then(res => {
      console.log(res.data);

      if(res.data!=''){ 
        /*this.setState({
          form: response.form,
          data: response.data,
        });*/
        //------------lo redirigimos -------------
        let id_preins = res.data.id_preins
        let idd = cApi.encrypt( id_preins.toString(),'eti')
        this.props.navigate('/estudiantep/e/'+idd);  

      }else{
          NotificationManager.error("No existen registros");
          this.limpiar();
      }

    }).catch(error => {
        alert("---- Existio un error, ---");
        console.log(error);
        
    });
  };
 
  //------------------------------------------------------
  //-----------------------------------------------
  aceptar_click = async () => {
    console.log("aceptar");
    
    this.refNuConfirm.current.show({
      message: 'Esta seguro de guardar?',
      title: 'Confirmation',
      icon: 'fa fa-question-circle',
      classHeader: 'bg-default1 ',
      classButton: 'btn btn-danger',
      accept: () => {
          
          this.save();
      },
      reject: () => {
          console.log('cancel');
      },
      acceptLabel: 'Aceptar',
      rejectLabel: 'Cancelar'
    })
 
  }

  //------------------------------------
  //======================================================     
  search_and_edit_form =( )=>{

    /*
    let fileURL = process.env.REACT_APP_API_URL  + 'estudiante_preins_pdf/'+ id_preins;
    let  windowFeatures = 'width=650,height= 700, left=100,top=100 ';
    window.open(fileURL,'',windowFeatures);
    */
    //----test encript
    let cad = cApi.encrypt('0','eti')
    console.log(cad)  //0=> 55
    //---buscamos el estudiante por su carned de identidad
    let nro_doc = this.state.form.nro_doc
    this.find_preins(nro_doc)

  }
  /************************************************ */
  //-----------------------------------
  save =() =>{
  const user = AuthService.getCurrentUser();
  const id_paciente = this.props.store.paciente.id_paciente;

  let param = {
                idd: this.state.form.idd,
                ope: this.state.form.ope,
                id_paciente: id_paciente,
                id_medico: user.id_u,
                t_tabla: JSON.stringify( this.state.data),
              };
  //console.log(param);
  axios2.post("receta_store", param)
  .then(res => {
      console.log(res.data);
      if(res.data.exito === 1){ 
          toast.success(res.data.mensaje);
                    
          
      }else{
          toast.error(res.data.mensaje);
      }

  }).catch(error => {
      alert("---- Existio un error ---");
      console.log(error);
      
  });
  
}
  //-------------------------------------
  render() {
    //------------ context API --------------
   
    //console.log( process.env.REACT_APP_AFILES + this.state.form.foto_path1 );
    const {form} = this.state;

    return (
      <div>
        <ToastContainer />

        {JSON.stringify(this.state.form)}
        {JSON.stringify(this.state.data)}

        <div className="content1">
          <div style={{ textAlign: 'center' }}>
            <strong>Formulario de preinscripción</strong>
          </div>

        </div>
        <br />

        <div className=" " style={{ padding: '16px 32px 32px 32px'}}>
          <div className="row">
            <div className="col-4">

              <div className="row">
                <div className="alert alert-info alert-dismissible">
                  <h4><i className="icon fa fa-info"></i> ESTUDIANTE NUEVO</h4>
                  Formulario de preinscripcion:<br/>
                    <Link to="/estudiantep/n/55" className="btn btn-info btn-post">REGISTRAR NUEVO ESTUDIANTE
                    </Link>
                </div>
              </div>

              <br/>
              <br/>

              <div className="row">
                <div className="alert alert-warning alert-dismissible">
                  <h4><i className="icon fa fa-warning"></i> REVISA QUE TUS DATOS, ESTEN CORRECTOS</h4>
                  Verifica tu pre-inscripcion, tambien puedes research_and_edit_form formulario de pre-inscripción
                  <br/>
                  <br/>
                  <b>C.I.:</b>

                  {/*<!-- buscador -->*/}
                  <div className="input-group">
                      <input  type="text" 
                              className="form-control" 
                              placeholder=""
                              name='nro_doc' 
                              value={this.state.form.nro_doc}
                              onChange={this.handleChangeForm}
                      />

                      <div className="input-group-append">
                        <Button className="btn btn-primary" type="button"
                          onClick={this.search_and_edit_form} 
                          >
                          <i className="fa fa-search"></i>
                        </Button>
                      </div>

                  </div>

                </div>

              </div>

            </div>

            <div className="col-8">

              <div className="alert alert-success alert-dismissible">
                <h4><i className="icon fa fa-info"></i> CARRERAS Y CURSOS DISPONIBLES </h4>
                Lista de carreras ó cursos para inscribirte, con sus horarios
                <br/>
                  {/*<!--<a href="#" className="btn btn-success btn-view" >CARRERAS Y CURSOS DISPONIBLES</a>-->*/}

                  <table className="table table-striped table-hover ">
                    <thead>
                      <tr>
                        <th width="40px">Nro</th>
                        <th>Carrera</th>
                      </tr>
                    </thead>
                    <tbody>
                    { this.state.arr_carr_preins.map((item,index) =>(
                      <tr  className="" key={index} >
                        <td>{ item.id_carre }</td>
                        <td>{ item.nombreca }</td>
                      </tr>
                    ))}
                      
                    </tbody>
                  </table>
              </div>

            </div>

            
          </div>
          <NuConfirm ref={this.refNuConfirm} />
        </div>
      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim( EstudiantePreins );